import React from 'react';
import {
    Nav,
    NavList,
    NavListItem,
    NavLink,
    ColorModeSwitcher
} from 'smooth-doc/components';

import LanguageSwitch from './LanguageSwitch';

export function AppNav () {
    return (
        <Nav>
            <NavList>
                <NavListItem>
                    <LanguageSwitch />
                </NavListItem>
                <NavListItem>
                    <NavLink as={ColorModeSwitcher} />
                </NavListItem>
            </NavList>
        </Nav>
    );
}
